import axios from 'axios'
import BaseService from './base'

export default class ReducceService extends BaseService {
    redirect () {
        return axios.get(`${this.host}/reducce/redirect/`)
    }
}
